import {
    createContext,
    useContext,
    type PropsWithChildren,
    useMemo
} from "react";

export interface TelemetryContextValue {
    track: (eventName: string, payload?: Record<string, unknown>) => void;
    trackError: (eventName: string, error: unknown) => void;
}

const noop = () => {
    // noop
};

const defaultValue: TelemetryContextValue = {
    track: noop,
    trackError: noop
};

const TelemetryContext =
    createContext<TelemetryContextValue>(defaultValue);

export const TelemetryContextProvider = ({
    children,
    value
}: PropsWithChildren<{ value?: TelemetryContextValue }>): JSX.Element => {
    const safeValue = useMemo(
        () => value ?? defaultValue,
        [value]
    );

    return (
        <TelemetryContext.Provider value={safeValue}>
            {children}
        </TelemetryContext.Provider>
    );
};

export const useTelemetry = (): TelemetryContextValue =>
    useContext(TelemetryContext);